import React from "react";
import { HashRouter as Router } from "react-router-dom";
import {
  StylesProvider,
  ThemeProvider as MuiThemeProvider,
} from "@material-ui/core/styles";
import { ThemeProvider } from "styled-components";
import theme from "../theme/theme";
import Routes from "./routes/index";

// Load css
import "./styles/style.scss";

export default () => (
  <ThemeProvider theme={theme}>
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={theme}>
        <Router>
          <Routes />
        </Router>
      </MuiThemeProvider>
    </StylesProvider>
  </ThemeProvider>
);
